import styled from 'styled-components';

import Color from '../../styles/color';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 48px;

  input {
    width: 100%;
    height: 48px;
    border: 1px solid ${Color.neutral80};
    box-sizing: border-box;
    background: ${Color.white};
    border-radius: 6px;
    font-size: 16px;
    padding: 0px 16px;
    color: ${Color.neutral};
    ::placeholder {
      color: ${Color.neutral80};
    }
  }

  .error {
    display: block;
    font-size: 12px;
    color: ${Color.error};
    margin-top: 10px;
    margin-left: 2px;
  }
`;
